let topUpBlocked = false;

/**
 * Check if top-up should be blocked (subscription + subscription)
 * @param {boolean} productHasAutorenew - Whether the current product has autorenew
 * @returns {boolean} - True if the top-up should be blocked
 */
function checkTopUpBlocked(productHasAutorenew) {
  const topUpHasAutorenew = sessionStorage.getItem("topUpHasAutorenew");
  const isTopUpFlow = sessionStorage.getItem("topUpIccid");

  // Block if we're in a top-up flow AND both the existing eSIM and new product have autorenew
  if (isTopUpFlow && topUpHasAutorenew === "true" && productHasAutorenew === true) {
    topUpBlocked = true;
    return true;
  }

  topUpBlocked = false;
  return false;
}

/**
 * Disable add to cart buttons when top-up is blocked
 */
function disableAddToCartButtons() {
  const addToCartButtons = document.querySelectorAll('[name="add"], .product-form__submit, button[type="submit"]');
  addToCartButtons.forEach((button) => {
    if (button.closest("product-form") || button.closest(".product-form")) {
      button.disabled = true;
      button.style.opacity = "0.5";
      button.style.cursor = "not-allowed";
      button.setAttribute("title", "Cannot add subscription to an eSIM with an existing subscription");
    }
  });
}

/**
 * Adjust the product page to show the top-up UI
 * */
function setupTopUpUI(setup_options) {
  document.getElementById("MainContent").classList.add("top_up");

  let productPageHeading = document.getElementById("product-text-overlay");
  if (productPageHeading) {
    productPageHeading.innerHTML = productTranslations.top_up_esim;
  }

  if (setup_options && setup_options.change_title != null && setup_options.change_title == "none") {
    let productPageBanner = document.getElementById("product_image_heading");
    if (productPageBanner) {
      productPageBanner.innerHTML = productTranslations.top_up_esim;
    }
  } else if (setup_options && setup_options.change_title != null && setup_options.change_title == "product_title") {
    /* Do nothing, title will come from product */
  } else if (setup_options && setup_options.change_title != null) {
    let productPageBanner = document.getElementById("product_image_heading");
    if (productPageBanner) {
      productPageBanner.innerHTML = setup_options.change_title;
    }
  }

  if (setup_options && setup_options.change_subheading != null && setup_options.change_subheading != "none") {
    let productPageSubheading = document.getElementById("product_image_text");
    if (productPageSubheading) {
      productPageSubheading.innerHTML = setup_options.change_subheading;
    }
  }

  let productTextItems = document.querySelectorAll(".product__info-container p");
  if (productTextItems && productTextItems.length > 0) {
    for (let i = 0; i < productTextItems.length; i++) {
      let textRegEx = new RegExp(productTranslations.travel_bundle, "ig");
      productTextItems[i].innerHTML = productTextItems[i].innerHTML.replaceAll(
        textRegEx,
        productTranslations.top_up_bundle
      );
    }
  }

  let topUpBannerText = document.getElementById("top_up_banner_text");
  if (topUpBannerText) {
    topUpBannerText.innerText = topUpBannerText.innerText + " " + sessionStorage.getItem('topUpIccid');
  }

  let topUpHiddenTextSections = document.querySelectorAll(".text_with_title_container.display-for-new");

  if (topUpHiddenTextSections && topUpHiddenTextSections.length > 0) {
    for (let i = 0; i < topUpHiddenTextSections.length; i++) {
      topUpHiddenTextSections[i].remove();
    }
  }
}

/**
 * Remove the active iccid from sessionStorage, cancelling a top-up selection process
 */
async function cancelTopUp() {
  try {
    const response = await fetch("/cart.js", {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });
    const resp = await response.json();
    var nullHash = {};
    for (const [key, value] of Object.entries(resp.attributes)) {
      nullHash[key] = null;
    }
    await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ attributes: nullHash }),
    });
  } catch (error) {
    console.error("Error updating cart attributes:", error);
  }
  
  try {
    await fetch("/cart/clear.json", {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    });
  } catch (error) {
    console.error("Error clearing cart:", error);
  }

  sessionStorage.removeItem("topUpIccid");
  sessionStorage.removeItem("topUpCurrentBundle");
  location.reload();
}

class CartWatcher {
  init() {
    this.emitCartChanges().then(() => {
      this.observeCartChanges();
    });
  }

  async fetchCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }

  storeCart(cart) {
    localStorage.setItem('cart', JSON.stringify(cart));
  }

 storedCart() {
    return JSON.parse(localStorage.getItem('cart')) || { items: [] };
  }

 findCartChanges(oldCart, newCart) {
    const onlyInLeft = (l, r) => l.filter(li => !r.some(ri => li.key == ri.key));
    let result = {
      added: onlyInLeft(newCart.items, oldCart.items),
      removed: onlyInLeft(oldCart.items, newCart.items),
    };

    oldCart.items.forEach(oi => {
      const ni = newCart.items.find(i => i.key == oi.key && i.quantity != oi.quantity);
      if (!ni) return;
      let quantity = ni.quantity - oi.quantity;
      let item = { ...ni };
      item.quantity = Math.abs(quantity);
      quantity > 0
        ? result.added.push(item)
        : result.removed.push(item)
    });

    return result;
  }

  async emitCartChanges() {
    const newCart = await this.fetchCart();
    const oldCart = this.storedCart();
    const changes = this.findCartChanges(oldCart, newCart);

    const event = new CustomEvent("cart_changed", { detail: changes });
    window.dispatchEvent(event);

    this.storeCart(newCart);
  }

 observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
        const isCartChangeRequest = /\/cart\//.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          this.emitCartChanges();
        }
      });
    });
    cartObserver.observe({ entryTypes: ["resource"] });
  }
}